import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom"
import ReactGA from 'react-ga4';

function HeaderNew() {

    const navigate = useNavigate()
    const currentUrl = window.location.pathname;

    const [headerLink, setHeaderLink] = useState({ path: '', state: false })

    useEffect(() => {
        if (headerLink.state) {
            navigate('/' + headerLink.path)
            setHeaderLink({})
        }
        // eslint-disable-next-line 
    }, [headerLink, currentUrl])

    const handleCheckoutBtn = () => {
        ReactGA.event({
            action: "Checkout page",
            category: "User interaction",
            label: "Checkout page"
        })
    }

    return (
        <header className="w-full bg-[#161623] h-[60px]">
            <div className='h-full container mx-auto max-w-4xl flex items-center justify-between'>
                <Link to="/">
                    <img src="assets/blogcode-logo.png" alt="blogcode" className="w-7/8" />
                </Link>
                <nav className='text-gray-200 w-full flex justify-center text-base'>
                    <ul className='flex gap-8 tracking-wide items-center'>
                        <li className="hidden sm:block">{currentUrl === "/" ? <a href="#pricing">Pricing</a> : <span onClick={() => setHeaderLink({ path: '#pricing', state: true })}> Pricing</span>}</li>
                        <li className="hidden sm:block">{currentUrl === "/" ? <a href="#features">Features</a> : <span onClick={() => setHeaderLink({ path: '#features', state: true })}> Features</span>}</li>
                        <Link to="/blogs" >Blogs</Link>
                    </ul>
                </nav>
                <Link to="/checkout" className='bg-[#2196f3] text-gray-100 py-2 px-4 tracking-wider rounded relative group overflow-hidden self-center mt-2 text-sm min-w-fit' onClick={() => handleCheckoutBtn()}>
                    <span className='inline-block'>Get BlogCode</span>
                    <span className='inline-block ml-2 transition-transform group-hover:translate-x-2'>→</span>
                </Link>
            </div>
        </header>
    )
}

export default HeaderNew